<template>
  <form @submit.prevent="handleSubmit" id="template_edit_form" enctype="multipart/form-data">
    <!-- Template Name -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Template Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="edit_name" name="name" ref="name"
        v-model="form.name" placeholder="Template Name" />
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Doc No <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" id="edit_doc_no" name="doc_no" ref="doc_no"
        v-model="form.doc_no" placeholder="Document Number" />
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Attachment File</label>
      <input type="file" class="form-control form-control-thin" id="edit_file" name="file" 
        @change="form.file = $event.target.files[0]" />
      <small class="text-muted">Max size: 10MB</small>
      <div v-if="form.existing_file" class="mt-1">
        <span class="badge bg-info">Current file: {{ form.existing_file }}</span>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label form-label-thin">Description If Any</label>
      <textarea class="form-control form-control-thin" id="edit_description" name="description" ref="description"
        v-model="form.description" placeholder="Template Description" rows="2"></textarea>
    </div>
   
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-sm btn-outline-secondary hover-white" @click="close" :disabled="submitting">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn" :disabled="submitting">
        <span v-if="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
        <i v-else class="fa fa-save me-1"></i>
        {{ submitting ? 'Updating...' : 'Update Template' }}
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'EditTemplate',
  emits: ['updated', 'close'],
  data() {
    return {
      form: {
        name: '',
        doc_no: '',
        description: '',
        file: null,
        existing_file: null,
        external_id: null
      },
      submitting: false,
      templateId: null
    }
  },
  methods: {
    setTemplateData(template) {
      this.templateId = template.id
      this.form.external_id = template.external_id
      this.form.name = template.name || ''
      this.form.doc_no = template.doc_no || ''
      this.form.description = template.description || ''
      this.form.existing_file = template.file || null
      this.form.file = null
    },

    resetForm() {
      this.templateId = null
      this.form = {
        name: '',
        doc_no: '',
        description: '',
        file: null,
        existing_file: null,
        external_id: null
      }
    },

    async handleSubmit() {
      if (!this.templateId) {
        this.$toast('Invalid template ID', false)
        return
      }

      this.submitting = true

      try {
        const result = await form_api_submit({
          url: 'template/update/' + this.templateId,
          method: 'POST',
          data: this.form,
          take_form_data: true,
          curr_form_id: '#template_edit_form',
        })

        if (result.success) {
          this.$emit('updated', result.data)
          this.close()
          this.resetForm()
        }
      } catch (error) {
        console.error('Error updating template:', error)
        this.$toast('Failed to update template', false)
      } finally {
        this.submitting = false
      }
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.form-label-thin {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 4px;
}

.form-control-thin {
  font-size: 13px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1.5px solid #e0e0e0;
  transition: border-color 0.2s;
}

.form-control-thin:focus {
  border-color: #667eea;
  outline: none;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.spinner-border-sm {
  width: 16px;
  height: 16px;
  border-width: 2px;
}
</style>